import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
var _class;
import { PureComponent } from 'react';
import { EditorView } from './editor-view';
import { observer } from '@alilc/lowcode-editor-core';
import './resource-view.less';
import { TopArea } from '@alilc/lowcode-editor-skeleton';
export var ResourceView = observer(_class = /*#__PURE__*/function (_PureComponent) {
  _inheritsLoose(ResourceView, _PureComponent);
  function ResourceView() {
    return _PureComponent.apply(this, arguments) || this;
  }
  var _proto = ResourceView.prototype;
  _proto.render = function render() {
    var skeleton = this.props.resource.skeleton;
    var editorViews = this.props.window.editorViews;
    return /*#__PURE__*/React.createElement("div", {
      className: "workspace-resource-view"
    }, /*#__PURE__*/React.createElement(TopArea, {
      area: skeleton.topArea,
      itemClassName: "engine-actionitem"
    }), /*#__PURE__*/React.createElement("div", {
      className: "workspace-editor-body"
    }, Array.from(editorViews.values()).map(function (editorView) {
      return /*#__PURE__*/React.createElement(EditorView, {
        key: editorView.name,
        active: editorView.active,
        editorView: editorView
      });
    })));
  };
  return ResourceView;
}(PureComponent)) || _class;